import React from 'react';
import Select from "../../common/primitives/Select";
import MasonryLayout from "../../common/primitives/Masonry";

import styles from './DomainAdditionalInfo.scss';

import BaseComponent from "../../common/BaseComponent/BaseComponent";

import ContextDomainAdditionalInfo from "../../context/ContextDomainAdditionalInfo";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";

class DomainAdditionalInfo extends BaseComponent {

	static contextType = ContextDomainAdditionalInfo;

	currentVideoId = null;
	videoLoading = false;


	videos = {};
	videoRefs = {};

	constructor(props) {
		super(props);
		this.state = {
			selectedCategory: 'selected'
		};
	}

	eventConsume(actionName) {
		if (actionName === 'WistiaVideoLoaded') {
			this.videoLoading = false;
			this.setState(this.state);
		}
	}

	playVideo = (videoId) => {
		this.videoLoading = true;
		this.setState(this.state);
		if (this.videoRefs[videoId]) {
			this.videoRefs[videoId].current.videoHandle.play();
			this.videoLoading = false;
			this.setState(this.state);
		} else {
			const hashedId = videoId;
			this.currentVideoId = videoId;

			import(/* webpackChunkName: "/chunks/WistiaEmbed" */ '../../common/primitives/WistiaEmbed')
			  .then(module => {
				  this.videoRefs = {...this.videoRefs, [videoId]: React.createRef()};
				  this.videos = {
					  ...this.videos, [videoId]: React.createElement(module.default, {
						  hashedId: hashedId,
						  ref: this.videoRefs[videoId]
					  })
				  };

				  this.setState(this.state);
			  });
		}
	};


	render() {
		const {
			categories,
			categories_en,
			data,
			data_en
		} = this.context;

		let categoriesArr = SHVO.pageLang === 'en' ? categories_en : categories;
		let dataArr = SHVO.pageLang === 'en' ? data_en : data;

		return (
		  <div className={`${styles.container} ${this.props.isMobile ? styles.mobile : ''}`}>
			  {
				  this.props.isMobile ?
					<Select
					  name='domain_info_categories'
					  options={categoriesArr}
					  selected={this.state.selectedCategory}
					  onChange={(selected) => this.setState({...this.state, selectedCategory: selected.value})}/>
					: <div>
						<ul className={styles.categoriesList}>
							{
								categoriesArr.map((category, key) => <li key={key}
																		 className={category.value === this.state.selectedCategory ? styles.active : ''}>
									<Button
									  onClick={() => this.setState({
										  ...this.state,
										  selectedCategory: category.value
									  })}
									  name={`toggle_category_additional_${category.value}`}
									  value={category.label}
									  className={`${buttons.buttonLink} ${buttons.action}`}/>
								</li>)
							}
						</ul>
					</div>
			  }
			  <div data-layout='margin-top--20'>
				  <MasonryLayout columns={this.props.isMobile ? 1 : 2} gap={this.props.isMobile ? 10 : 30}>
					  {
						dataArr[this.state.selectedCategory] && dataArr[this.state.selectedCategory].map((block, key) => {
							const {hasVideo, videoId, videoThumb, heading, url, description} = block;
							return (
							  <section key={key} className={styles.block}>
								  {
									hasVideo &&
									<div
									  className={styles.videoContainer}
									  style={{backgroundImage: `url("${videoThumb}")`}}
									  onClick={() => this.playVideo(videoId)}>
									</div>
								  }

								  <div className={styles.description}>
									  <h3>
										  {
											  url !== '' ?
												<a href={url} title={heading} target='_blank'
												   rel='noreferrer noopener'>{heading}</a>
												: heading
										  }
									  </h3>
									  {
										description !== '' &&
										<p>{description}</p>
									  }
								  </div>
							  </section>
							);
						})
					  }
				  </MasonryLayout>
			  </div>

			  {
				this.videos && Object.keys(this.videos).map((key) => <div key={key}>{this.videos[key]}</div>)
			  }
		  </div>
		);
	}
}

export default DomainAdditionalInfo;
